"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTENT_SHA256_HEADER = exports.CANCELED_ERROR_CODE = exports.CANCELED_ERROR_MESSAGE = exports.ABORT_ERROR_CODE = exports.ABORT_ERROR_MESSAGE = exports.NETWORK_ERROR_CODE = exports.NETWORK_ERROR_MESSAGE = exports.SEND_DOWNLOAD_PROGRESS_EVENT = exports.SEND_UPLOAD_PROGRESS_EVENT = void 0;
exports.SEND_UPLOAD_PROGRESS_EVENT = 'sendUploadProgress';
exports.SEND_DOWNLOAD_PROGRESS_EVENT = 'sendDownloadProgress';
exports.NETWORK_ERROR_MESSAGE = 'Network Error';
exports.NETWORK_ERROR_CODE = 'ERR_NETWORK';
exports.ABORT_ERROR_MESSAGE = 'Request aborted';
exports.ABORT_ERROR_CODE = 'ERR_ABORTED';
exports.CANCELED_ERROR_MESSAGE = 'canceled';
exports.CANCELED_ERROR_CODE = 'ERR_CANCELED';
exports.CONTENT_SHA256_HEADER = 'x-amz-content-sha256';
